<ng-container *ngIf="jobExtensionFormGroup" [formGroup]="jobExtensionFormGroup">
    <ng-container *ngIf="viewMode === 'all'; else extensionContent">
        <ion-accordion [value]="jobExtensionFormGroup.value._id" class="job-extension-accordion" mode="md">
            <ion-item slot="header">
                <ion-label>
                    {{ jobExtensionFormGroup.value.article.name }}
                    <small class="job-extension-header-info" (click)="managementChangesAllowed && onChangeJobExtensionWorker($event)">
                        {{ jobExtensionFormGroup.value.worker }}
                    </small>
                    <small class="job-extension-header-info" (click)="managementChangesAllowed && onChangeJobExtensionDate($event)">
                        {{
                            'projects.jobs.details.worker-created-at-info'
                                | translate
                                    : {
                                          createdAt: (jobExtensionFormGroup.value.date | date: 'dd.MM.y'),
                                      }
                        }}
                    </small>
                </ion-label>
                <ion-reorder slot="end" *ngIf="reorderActive"></ion-reorder>
                <ion-buttons slot="end" *ngIf="changesAllowed && !reorderActive">
                    <ion-button
                        fill="clear"
                        size="small"
                        class="job-lock-icon round"
                        (click)="!job.locked && onManuallyLockJobExtension(); $event.stopPropagation()"
                        [color]="job.locked || jobExtensionFormGroup.get('locked').value ? 'danger' : 'dark'"
                    >
                        @if (job.locked || jobExtensionFormGroup.value.locked) {
                            <fa-icon
                                dpTooltip
                                tooltipTrigger="click mouseenter focus"
                                [tooltipContent]="
                                    !settingsSrv.currentUserRights.canUnlockJobs || !changesAllowed
                                        ? ('projects.jobs.details.unlock-not-allowed' | translate)
                                        : undefined
                                "
                                icon="lock"
                                slot="icon-only"
                            ></fa-icon>
                        } @else {
                            <fa-icon
                                dpTooltip
                                tooltipTrigger="click mouseenter focus"
                                [tooltipContent]="
                                    !settingsSrv.currentUserRights.canLockJobs || !changesAllowed
                                        ? ('projects.jobs.details.lock-not-allowed' | translate)
                                        : undefined
                                "
                                icon="unlock"
                                slot="icon-only"
                            ></fa-icon>
                        }
                    </ion-button>
                    <ng-container *ngIf="!job.locked && !jobExtensionFormGroup.get('locked').value">
                        <ng-container *ngIf="!utils.mobileViewActive">
                            <ion-button
                                fill="clear"
                                size="small"
                                class="round"
                                color="primary"
                                (click)="onDuplicateJobExtension($event)"
                                *ngIf="duplicationAllowed"
                            >
                                <fa-icon icon="clone" slot="icon-only"></fa-icon>
                            </ion-button>
                        </ng-container>
                        <ion-button
                            [fill]="utils.mobileViewActive ? 'outline' : 'clear'"
                            size="small"
                            class="round"
                            color="primary"
                            dpTooltip
                            tooltipTheme="light"
                            tooltipPosition="left"
                            tooltipTrigger="click mouseenter focus"
                            tooltipInteractive="true"
                            hideTooltipAfterInteraction="true"
                            [tooltipContent]="jobExtensionAdminActionsDropdown"
                            (click)="actionsButton($event)"
                        >
                            <fa-icon icon="ellipsis-h" slot="icon-only"></fa-icon>
                        </ion-button>
                        <ng-template #jobExtensionAdminActionsDropdown>
                            <div class="dropdown-links">
                                <ion-list class="bg-white">
                                    <ion-item
                                        class="no-padding bg-white"
                                        lines="none"
                                        button
                                        detail="false"
                                        (click)="onRefreshJobExtensionFields()"
                                    >
                                        <fa-icon icon="arrows-rotate" class="color-black dp-mr-s"></fa-icon>
                                        <ion-label>{{ 'projects.jobs.details.refresh-fields-btn' | translate }}</ion-label>
                                    </ion-item>
                                    <ng-container *ngIf="utils.mobileViewActive">
                                        <ion-item
                                            class="no-padding bg-white"
                                            lines="none"
                                            button
                                            detail="false"
                                            (click)="onDuplicateJobExtension()"
                                            *ngIf="duplicationAllowed"
                                        >
                                            <fa-icon icon="clone" class="color-black dp-mr-s"></fa-icon>
                                            <ion-label>{{ 'shared.duplicate' | translate }}</ion-label>
                                        </ion-item>
                                    </ng-container>
                                    <ng-container>
                                        <ion-item
                                            class="no-padding bg-white"
                                            lines="none"
                                            button
                                            detail="false"
                                            (click)="onOpenArticleHelp()"
                                        >
                                            <fa-icon icon="info-circle" class="color-black dp-mr-s"></fa-icon>
                                            <ion-label>{{ 'projects.jobs.details.article-help-title' | translate }}</ion-label>
                                        </ion-item>
                                        <ion-item
                                            class="no-padding bg-white color-danger danger-item"
                                            lines="none"
                                            button
                                            detail="false"
                                            (click)="onDeleteJobExtension()"
                                            *ngIf="deletionAllowed"
                                        >
                                            <fa-icon icon="trash" class="color-danger dp-mr-s"></fa-icon>
                                            <ion-label>{{ 'shared.delete' | translate }}</ion-label>
                                        </ion-item>
                                    </ng-container>
                                </ion-list>
                            </div>
                        </ng-template>
                    </ng-container>
                </ion-buttons>
            </ion-item>
            <div slot="content">
                <ng-container *ngIf="extensionExpanded">
                    <ng-container *ngTemplateOutlet="extensionContent"></ng-container>
                </ng-container>
            </div>
        </ion-accordion>
    </ng-container>
    <ng-template #extensionContent>
        <!-- View for Article Field Display Mode -->
        <ion-row
            class="job-extension-wrap"
            *ngIf="viewMode === 'all'"
            [ngClass]="this.jobExtensionFormGroup.get('locked').value ? 'job-locked' : ''"
        >
            <ion-col class="dp-pt-0">
                <app-job-article
                    [viewMode]="viewMode"
                    [articleFormGroup]="jobExtensionFormGroup.get('article')"
                    [job]="job"
                    [jobExtensionId]="
                        jobExtensionFormGroup.get('version')?.value > -1 ? jobExtensionFormGroup.get('_id').value : 'new-job-extension'
                    "
                    [serviceGroupPhotoCategoriesCount]="serviceGroupPhotoCategoriesCount"
                    [changesAllowed]="changesAllowed && !job.locked && !jobExtensionFormGroup.get('locked').value"
                    [asDialog]="asDialog"
                    (articleFormGroupChanged)="jobExtensionFormGroupChanged.emit()"
                    (jobSaveRequested)="jobSaveRequested.emit()"
                    (lockRequested)="lockRequested.emit($event)"
                    (removedJobLinkId)="removedJobLinkId.emit($event)"
                    (addedJobLinkId)="addedJobLinkId.emit($event)"
                    #articleComponent
                ></app-job-article>
            </ion-col>
        </ion-row>

        <!-- View for Photos Display Mode -->
        <ion-row
            class="job-extension-wrap"
            *ngIf="viewMode === 'photos-only' && jobExtensionFormGroup.get('article').get('photoCategories').value.length > 0"
        >
            <ion-col>
                <ion-card class="job-extension-card">
                    <ion-card-header class="ion-no-padding">
                        <ion-toolbar>
                            <ion-title mode="md" class="ion-no-padding">
                                <ion-card-title class="ion-text-wrap">
                                    {{ jobExtensionFormGroup.get('article').get('name').value }}
                                    <small
                                        class="job-extension-header-info"
                                        (click)="managementChangesAllowed && onChangeJobExtensionWorker($event)"
                                    >
                                        {{ jobExtensionFormGroup.value.worker }}
                                    </small>
                                    <small>
                                        {{
                                            'projects.jobs.details.worker-created-at-info'
                                                | translate
                                                    : {
                                                          createdAt: (jobExtensionFormGroup.value.date | date: 'dd.MM.y'),
                                                      }
                                        }}
                                    </small>
                                </ion-card-title>
                            </ion-title>
                        </ion-toolbar>
                    </ion-card-header>
                    <ion-card-content>
                        <app-job-article
                            [viewMode]="viewMode"
                            [articleFormGroup]="jobExtensionFormGroup.get('article')"
                            [job]="job"
                            [jobExtensionId]="
                                jobExtensionFormGroup.get('version')?.value > -1
                                    ? jobExtensionFormGroup.get('_id').value
                                    : 'new-job-extension'
                            "
                            [serviceGroupPhotoCategoriesCount]="serviceGroupPhotoCategoriesCount"
                            [changesAllowed]="changesAllowed && !job.locked && !jobExtensionFormGroup.get('locked').value"
                            [asDialog]="asDialog"
                            (articleFormGroupChanged)="jobExtensionFormGroupChanged.emit()"
                            (jobSaveRequested)="jobSaveRequested.emit()"
                            (lockRequested)="lockRequested.emit($event)"
                            (removedJobLinkId)="removedJobLinkId.emit($event)"
                            (addedJobLinkId)="addedJobLinkId.emit($event)"
                            #articleComponent
                        ></app-job-article>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ng-template>
</ng-container>

<!-- Popover for Job Extension Worker Changes -->
<ion-popover
    size="auto"
    class="job-extension-worker-popover"
    #jobExtensionWorkerPopover
    [keepContentsMounted]="extensionExpanded"
    [showBackdrop]="false"
>
    <ng-template>
        <ion-content class="ion-padding">
            <ng-container *ngIf="jobExtensionFormGroup" [formGroup]="jobExtensionFormGroup">
                <ion-select
                    class="bg-light"
                    [label]="'projects.jobs.details.creator-label' | translate"
                    fill="outline"
                    labelPlacement="floating"
                    interface="popover"
                    formControlName="worker"
                    [disabled]="!managementChangesAllowed"
                    (ionChange)="jobExtensionWorkerPopover.dismiss()"
                >
                    <ion-select-option *ngFor="let worker of possibleWorkers" [value]="worker.firstName + ' ' + worker.lastName">
                        {{ worker.firstName + ' ' + worker.lastName }}
                    </ion-select-option>
                </ion-select>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-popover>

<!-- Popover for Job Extension Date Changes -->
<ion-popover
    size="auto"
    class="job-extension-date-popover"
    #jobExtensionDatePopover
    [keepContentsMounted]="extensionExpanded"
    [showBackdrop]="false"
>
    <ng-template>
        <ion-content class="ion-padding">
            <ng-container *ngIf="jobExtensionFormGroup" [formGroup]="jobExtensionFormGroup">
                <app-date-time-picker
                    [timestamp]="jobExtensionFormGroup.get('date').value"
                    [changesAllowed]="managementChangesAllowed"
                    (dateChanged)="onJobExtensionDateChanged($event)"
                ></app-date-time-picker>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-popover>
